import { SortDirType } from "../../../common/SortDirType";
import { SortParams } from "../../../common/SortParams";

export const sortByFields = [
  { label: "Location Name", value: "LOCATION_NAME" },
  { label: "Daily Price", value: "PRICE_PER_DAY" },
  { label: "Monthly Price", value: "PRICE_PER_MONTH" },
] as const satisfies Array<{label: string, value: string}>;

export type LocationFavoriteSortByType = typeof sortByFields[number]['value'];

export interface LocationFavoriteSortParams extends SortParams {
  sortBy?: LocationFavoriteSortByType;
  sortDir?: SortDirType
}